import { icons } from '@shared/static/icons';
import { useTranslation } from 'react-i18next';

export default function RenderItemCardAction({ item }) {
  const { t } = useTranslation();

  if (!item) return null;
  return (
    <div className="render-select-icon">
      {icons[item.icon]}
      {t(item.label)}
    </div>
  );
}
